export default "assets/f5943206dee46bb1.svg"